import { GraphQLResult } from 'aws-amplify/api';
import {
  CreateMeetingHostEventsMutationVariables,
  ListMeetingHostEventsQuery,
  ListMeetingHostEventsQueryVariables,
  UpdateMeetingHostEventsMutationVariables,
} from '@/services/API';
import { createMeetingHostEvents, updateMeetingHostEvents } from '@/services/graphql/mutations';
import { listMeetingHostEvents } from '@/services/graphql/queries';
import { callGraphQLApi } from '@/utils/graphQLAPI';
import { HostTrackingObj } from './HostTrackingProvider';

export const createOrUpdateHostTracking = async (meetingId: string, obj: HostTrackingObj) => {
  const variables: ListMeetingHostEventsQueryVariables = {
    filter: {
      meetingID: {
        eq: meetingId,
      },
    },
  };
  const response = await callGraphQLApi<GraphQLResult<ListMeetingHostEventsQuery>>(
    listMeetingHostEvents,
    variables
  );
  const objs = response.data.listMeetingHostEvents?.items || [];
  if (objs.length > 0) {
    const updateVariables: UpdateMeetingHostEventsMutationVariables = {
      input: {
        id: objs[0]!.id,
        stringifiedJSONEvents: JSON.stringify(obj),
      },
    };
    await callGraphQLApi(updateMeetingHostEvents, updateVariables);
  } else {
    const createVariables: CreateMeetingHostEventsMutationVariables = {
      input: {
        stringifiedJSONEvents: JSON.stringify(obj),
        meetingID: meetingId,
      },
    };
    await callGraphQLApi(createMeetingHostEvents, createVariables);
  }
};
